import React from 'react'
import "./about.css"
import Award from "./../../img/award.png"

const About = () => {
    return (
        <div className="a">
            <div className="a-left">
                <div className="a-card bg"></div>
                <div className="a-card">
                    <img src="https://images.pexels.com/photos/3183165/pexels-photo-3183165.jpeg?cs=srgb&dl=pexels-fauxels-3183165.jpg&fm=jpg" alt="" 
                        className="a-img"                   
                    />
                </div>
            </div>
            <div className="a-right">
                <h1 className="a-title">About Me</h1>
                <p className="a-sub">
                    Believe in Yourself !
                </p>
                <p className="a-desc">
                    well i am danish am a software developer i build website web applications
                    mobile apps android ios developed software for specific requirements.
                    I like to do travel alot i am passionate about to see different cultures 
                </p>
                <div className="a-award">
                    <img src={Award} alt="" className="a-award-img"/>
                    <div className="a-award-texts">
                        <h4 className="a-award-title">International Desing Award 2021</h4>
                        <p className="a-award-desc">
                            this is the award that i got in International design festival
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About

